export default "__VITE_ASSET__949c8492__"